import BaseService from '@/services/base.service';
import { getConfigSetup } from '@/utils/utils';

const configSetup = getConfigSetup();

class ResultService extends BaseService {
    async getList(date?: string) {
        const payload: any = {
            account: configSetup.account,
            page: 2,
        };

        if (date) {
            payload['date'] = date;
        }

        const resp = await this.postAuth2(`${configSetup.apiGame}/api/multi-lotto/results`, payload).then(
            ({ data }) => data,
        );

        return resp;
    }

    async getListDaily(date?: string) {
        const payload: any = {
            account: configSetup.account
        };

        if (date) {
            payload['date'] = date;
        }

        const resp = await this.postAuth2(`${configSetup.apiGame}/api/v2/fixed-daily-lotto/results`, payload).then(
            ({ data }) => data,
        );

        return resp;
    }
}

export default new ResultService();
